import { Amplitude } from 'utils';
import appsFlyer from 'utils/packages/rnAppsflyer';
import { logAnalyticsEvent } from 'utils/packages/rnFirebase';
export const logPurchaseCompleteEvent = async (analyticsData, productId, store, isTrial, discountId) => {
    Amplitude.logEvent('Started Subscription Event', {
        productId,
        discountId,
        isTrial,
        currentScreen: analyticsData?.currentScreen,
        source: analyticsData?.previousScreen,
        benefitId: analyticsData?.benefitId,
        store,
    });
    const analyticsFlow = analyticsData?.analyticsFlow;
    if (analyticsData?.analyticsFlow) {
        logAnalyticsEvent('Free_Trial');
        if (analyticsFlow === 'NewOnboarding') {
            Amplitude.logEvent(`${analyticsFlow}.EmmaProTrial`, {
                productId,
            });
            try {
                await appsFlyer.logEvent(`${analyticsFlow}.EmmaProTrial`, {});
            }
            catch {
                // No op
            }
        }
        else if (analyticsFlow === 'EmmaProModal') {
            Amplitude.logEvent('EmmaProModal.EmmaProTrial', {
                productId,
                currentScreen: analyticsData.currentScreen,
            });
        }
        else if (analyticsFlow === 'PremiumPopup') {
            Amplitude.logEvent(`${analyticsFlow}.Purchased`, {
                productId,
            });
        }
    }
};
